import { hasAdminRole } from '../../../utils/authenticationUtils';
import { PageContainer } from '../../shared/PageContainer';
import SettingsIcon from '@mui/icons-material/Settings';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { trackState } from '../../../redux/track/trackSlice';
import { TrackPageActions } from '../../track/trackPage/TrackPageActions';
import { commonState } from '../../../redux/common/commonSlice';
import { useSearchParams } from 'react-router-dom';
import { getSearchCategory, getSearchProvider, initialSearchParams, updateSearchParamsForCategory, updateSearchParamsForProvider } from './configurationsPageHelper';
import { useEffect } from 'react';
import { loadTracks } from '../../../redux/track/trackAction';
import { categoryItems } from '../../shared/sharedHelper';
import { ConfigurationsList } from '../configurationsList/ConfigurationsList';
import { RppTitle } from '../../shared/RppTitle';

export const ConfigurationsPage = () => {

    const state = useAppSelector(trackState);
    const common = useAppSelector(commonState);
    const dispatch = useAppDispatch();

    const [searchParams, setSearchParams] = useSearchParams();

    const searchProvider = getSearchProvider(searchParams);
    const searchCategory = getSearchCategory(searchParams);

    const loadPageTracks = async () => {
        if (searchProvider) {
            await dispatch(loadTracks(searchProvider));
        }
    }


    const handleSearchProviderChange = (providerCode: string) => {
        setSearchParams(updateSearchParamsForProvider(searchParams, providerCode));
    }

    const handleSearchCategoryChange = (categoryCode: string) => {
        setSearchParams(updateSearchParamsForCategory(searchParams, categoryCode));
    }

    const handleRefresh = async () => {
        loadPageTracks();
    }

    const getDisplayTracks = () => {
        const filteredTracks = state.tracks.filter((t) =>
            t.categoryCode === searchCategory &&
            t.provider === searchProvider
        );
        return filteredTracks.toSorted((a, b) => a.sportCode! < b.sportCode! ? -1 : 1).toSorted((a, b) => ((a.shortDescription!.toLowerCase() < b.shortDescription!.toLowerCase() ? -1 : 1)));
    }

    const readOnly = !hasAdminRole();
    const tracks = getDisplayTracks();
    const categoryDesc = categoryItems.find(c => c.key === searchCategory)?.value;

    useEffect(() => {
        initialSearchParams(searchParams, common, setSearchParams);
    }, [common, searchParams, setSearchParams])

    useEffect(() => {
        loadPageTracks();
        // We want to restrict only on searchProvider
        // eslint-disable-next-line
    }, [searchProvider]);

    return (
        <PageContainer
            heading='Configurations'
            icon={<SettingsIcon />}
            rightElement={
                <TrackPageActions
                    providerCode={searchProvider ?? ''}
                    categoryCode={searchCategory ?? categoryItems[0].key}
                    onProviderCodeChange={handleSearchProviderChange}
                    onCategoryCodeChange={handleSearchCategoryChange}
                    onRefresh={handleRefresh}
                />
            }
        >
            <RppTitle title={`Configurations - ${searchProvider} ${categoryDesc}`} />
            <ConfigurationsList
                tracks={tracks}
                readOnly={readOnly}
            />
        </PageContainer>
    )
}
